module.exports = __webpack_public_path__ + "9ecb338fae3553665fd2632bb77a2b18.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/common/bookCovers/book1.png
 ** module id = 833
 ** module chunks = 0
 **/